<template>
  <CryptoDetails />
</template>

<script>
import CryptoDetails from '../../../components/crypto/CryptoDetails.vue'
export default {
  components: {
    CryptoDetails,
  },
}
</script>

<style scoped lang="scss"></style>
